import { AccountsContextData } from '../model/account-context-data';
import { cclFetch, generateUrlWithParams } from 'gocclr-shared-ui/dist/helpers';

export function getRawApplicationContextData(forceLoad: boolean): Promise<AccountsContextData> {
    const url = generateUrlWithParams('/accounts/initial-data', { forceLoad: forceLoad });
    return cclFetch<AccountsContextData>(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
}